import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';

const Container = styled.div``;
const STATE = {
  selected: null,
  legacyTransfer: false,
};
/* eslint-disable react/prefer-stateless-function */
class SilverdatOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;
    return <Container>Silverdat</Container>;
  }
}

SilverdatOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const SilverdatOverview = compose(
  withConnect,
  withRouter,
)(SilverdatOverviewComp);
